// taken from the error code definitions in the monolith
export const BAD_DEVICE_LOCATION = 101 as const;
export const BAD_SHIFT_LOCATION = 102 as const;
export const OUT_OF_RANGE_SHIFT_LOCATION = 103 as const;
export const NOT_NEAR_LOCATION = 104 as const;
export const CLOCK_IN_TOO_EARLY = 105 as const;
export const NO_SCHEDULED_SHIFT = 106 as const;

export const GEOLOCATION_ERRORS: number[] = [BAD_DEVICE_LOCATION, OUT_OF_RANGE_SHIFT_LOCATION, NOT_NEAR_LOCATION];
